module.exports = __webpack_public_path__ + "static/media/Druid_Resto.01406961.png";